import React from "react"
import HeadingL from "../../components/shared/HeadingL"
import Layout from "../../components/one/Layout"
import ProgramActivityExample from "../../components/one/ProgramActivityExample"
import ProgramSchedule from "../../components/one/ProgramSchedule"
import SEO from "../../components/Seo"
import { PAGE } from "../../constants"

const program = () => {
  return (
    <Layout>
      <SEO title={PAGE.title.program} siteTitle="one" />
      <HeadingL title={PAGE.title.program} target="one" />
      <ProgramSchedule />
      <ProgramActivityExample />
    </Layout>
  )
}

export default program
